import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Dropdown from './Dropdown'

const Navigation = (props) => {
    const data = useStaticQuery(graphql`
    query {
        menu: settingsJson(
            fileRelativePath: { eq: "/content/settings/menu.json" }
          ) {
            menuItems {
                label
                link
                submenuItems {
                    label
                    link
                }
            }
        }
    }`)
    const menu = data.menu

    return (
        <div id="navbar" className="navbar-collapse collapse">
            <ul className="nav navbar-nav">
                {menu.menuItems.map((item, i) => {
                    if (!item.submenuItems) {
                        return (
                            <li key={i} className="">
                                <a href={item.link} target="_self">
                                    <span>{item.label}</span>
                                </a>
                            </li>
                        )
                    } else {
                        return (
                            <Dropdown key={i} menu={item}/>
                        )
                    }
                })}
            </ul>
            <ul className="nav navbar-nav navbar-right inliney">
                <li><a href="https://www.facebook.com/instantcheckmate/" className="facebook" title="Facebook">Facebook</a></li>
                <li><a href="https://twitter.com/instntcheckmate" className="twitter" title="Twitter">Twitter</a></li>
                <li><a href="https://www.linkedin.com/company/instant-checkmate-llc" className="linkedin" title="LinkedIn">LinkedIn</a></li>
                <li><a href="https://www.youtube.com/user/instantcheckmates" className="youtube" title="YouTube">YouTube</a></li>
            </ul>
        </div>
    )
}

export const NavigationForm = {
    label: "Menu",
    fields: [
      {
        label: "Main Menu",
        name: "rawJson.menuItems",
        component: "group-list",
        itemProps: item => ({
          label: item.label,
        }),
        fields: [
          {
            label: "Label",
            name: "label",
            component: "text",
            parse(value) {
              return value || ""
            },
          },
          {
            label: "Link",
            name: "link",
            component: "text",
            parse(value) {
              return value || ""
            },
          },
          {
            label: "Sub Menu",
            name: "submenuItems",
            component: "group-list",
            itemProps: item => ({
              key: item.link,
              label: item.label,
            }),
            fields: [
              {
                label: "Label",
                name: "label",
                component: "text",
              },
              {
                label: "Link",
                name: "link",
                component: "text",
              },
            ],
          },
        ],
      },
    ],
  }
  

export default Navigation

